export const formatDate = (value: Date | null | undefined) => {
	return value ? value.toLocaleString("cs-CZ") : value;
};

export const formatDateLeadingZeroes = (value: Date | null | undefined) => {
	if (!value) return value;

	const formattedDate = new Intl.DateTimeFormat("cs-CZ", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
	}).format(value);

	return formattedDate
		.replace(/\s/g, "")
		.replace(/(\d{2}\.\d{2}\.\d{4}),?/, "$1 ");
};
